import { useSelector } from 'react-redux';

import More from '@plone/volto/components/manage/Toolbar/More';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import {
  podeVerToolbar,
  type MpfPermissoes,
} from 'volto-ministerio-publico-federal/helpers/Permissoes';

/** Ids dos Plugs do `More.jsx` que os perfis de acesso podem esconder. */
export const ITENS_DO_MAIS = ['state', 'view', 'history', 'sharing'];

const semConteudo = () => null;

/**
 * Menu "Mais" da toolbar com os itens escondidos pelo perfil de acesso.
 *
 * O `PluggablesProvider` guarda um renderer por id; um Plug com o mesmo id
 * montado depois do do `More` o substitui. Aqui o substituto não renderiza
 * nada — sem precisar sombrear o `More.jsx` inteiro.
 */
const MpfMore = (props: any) => {
  const permissoes = useSelector(
    (state: any) => state.mpfPermissoes?.data ?? null,
  ) as MpfPermissoes | null;
  const ocultos = ITENS_DO_MAIS.filter(
    (item) => !podeVerToolbar(permissoes, item),
  );

  return (
    <>
      <More {...props} />
      {ocultos.map((item) => (
        <Plug key={item} pluggable="toolbar-more-menu-list" id={item}>
          {semConteudo}
        </Plug>
      ))}
    </>
  );
};

export default MpfMore;
